/* eslint-disable arrow-body-style,import/no-cycle */
import {
    AccUser,
    AccUsers, CreateAccUser, ICreateAccUser, IUpdateAccUser, SendConfirmationEmailAgainForAccUser, UpdateAccUser,
} from '../../api/ApiClient';
import { createModel } from '@rematch/core';
import apiConnector from '../../api/ApiConnector';
import { IFilterPart, ISearchPart } from 'components/models';
import { IBodyIdPart } from 'components/reduxModels';


const initialState: State = {
    list: null,
    details: null,
};

export default createModel({
    state: initialState,
    reducers: {
        clearList(state: State): State {
            return { ...state, list: null };
        },

        setList(state: State, list: State['list']): State {
            return { ...state, list };
        },

        clearDetails(state: State): State {
            return { ...state, details: null };
        },

        setDetails(state: State, details: State['details']): State {
            return { ...state, details };
        },
    },
    effects: (dispatch: any) => ({
        async fetchUsersAsync(payload: ISearchPart & IFilterPart) {
            this.setList(await apiConnector.execApi(
              dispatch,
              apiClient => apiClient.getAccUsers(
                payload.searchField,
                payload.searchTerm,
                payload.page,
                payload.pageSize,
                payload.sortOrder,
                payload.sortField,
              ),
            ));
        },
        async fetchUserDetailsAsync(id: string) {
            this.setDetails(await apiConnector.execApi(
              dispatch,
              apiClient => apiClient.getAccUser(id),
            ));
        },
        async createUserAsync(payload: ICreateAccUser) {
            return apiConnector.execApi(
              dispatch,
              apiClient => apiClient.createAccUser(new CreateAccUser(payload)),
            );
        },
        async updateUserAsync(payload: IBodyIdPart<IUpdateAccUser>) {
            const result = await apiConnector.execApi(
              dispatch,
              apiClient => apiClient.updateAccUser(payload.id, new UpdateAccUser(payload.body)),
            );
            this.setDetails(result);

            return result;
        },
        async deleteUserAsync(id: string) {
            return apiConnector.execApi(
              dispatch,
              apiClient => apiClient.deleteAccUser(id),
            );
        },
        async sendConfirmationEmailAsync(id: string) {
            return apiConnector.execApi(
              dispatch,
              apiClient => apiClient.sendConfirmationEmailAgainForAcсUser(id, new SendConfirmationEmailAgainForAccUser()),
            );
        },
    }),
});

interface State {
    list: AccUsers | null;
    details: AccUser | null;
}
